PJQ.views.dailyReports.ExpenseManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Expense-Management')
	},
	events: {
		'click .add-expense': 'addClicked',
		'click .edit-expense': 'editClicked',
		'click .delete-expense': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminExpenses');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddExpenses') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.expenses-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Expense" to create a new expense' : 'No expenses were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				this.editExpense(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editExpense(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editExpense(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteExpense(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "40px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{"data": "attributes.description", "title": "Description", "width": "25%"},
				{
					"data": "attributes.cost",
					"title": "Cost",
					"searchable": false,
					"width": "100px",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatCurrency(data, 2, true);
					}
				},
				{
					"data": "group",
					"title": "Trade",
					"width": "15%",
					"render": function (data) {
						if (data) {
							return data.get('groupName');
						}
						return '';
					}
				},
				{
					"data": "attributes.notes",
					"title": "Notes",
					"orderable": false,
					"searchable": false
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-expense ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-expense ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-expense ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newExpense = new PJQ.models.dailyReports.Expense({
			dailyReportId: this.options.dailyReport.id,
			description: "",
			cost: 0,
			notes: ""
		});
		this.editExpense(newExpense);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			expense = row.data();
		this.editExpense(expense);
	},
	editExpense: function (expense) {
		new PJQ.views.dailyReports.EditExpenseModal({
			model: expense,
			isLocked: this.options.isLocked,
			project: this.options.project,
			onSave: _.bind(function (expense) {
				if (expense.hasChanged() || expense.isNew()) {
					if (expense.isNew()) {
						this.collection.add(expense);
						this.dataTable.addRow(expense);
					}
					expense.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (expense) {
				if (expense.hasChanged()) {
					expense.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (expense) {
				if (expense.id > 0) {
					let row = this.dataTable.getRow(expense.cid);
					this.collection.remove(expense);
					expense.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteExpense(row);
	},
	deleteExpense: function (row) {
		let expense = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this expense?",
			onDelete: _.bind(function () {
				this.collection.remove(expense);
				expense.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditExpenseModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Expense'),
		maxWidth: 800,
		subTemplates: {
			groupBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Groups-Select-Input-Groups')
		},
		isShowCloseButton: true
	},
	events: {
		'click .expense-save': 'onSave',
		'click .expense-close': 'close',
		'click .btn-expense-edit-group': 'editGroup',
		'click .group-select-input-delete': 'deleteGroup',
		'click .expense-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminExpenses');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddExpenses') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});
		}

		this.renderGroup();

		PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.expense-cost'), 2);

		this.paymentMethodSelectPicker = new PJQ.inputs.Selectpicker({
			el: $('.payment-method'),
			noneSelectedText: 'Select Payment Method',
			hideDisabled: false,
			isMultiple: false,
			defaultValue: this.model.get('paymentMethod'),
			onChange: _.bind(function () {
				this.model.set('paymentMethod', this.paymentMethodSelectPicker.getValue());
			}, this)
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.expense-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	renderGroup: function () {
		if (this.model.group != null) {
			this.renderSubTemplate(false, this.options.subTemplates.groupBadge, this.$('.expense-group'),
				{
					models: [this.model.group],
					isReadOnly: this.options.canEdit
				});
		}
		else {
			this.$('.expense-group').html('<div class="text-muted font-weight-light fs-16 mt-2">Not Selected</div>');
		}
	},
	editGroup: function () {
		new PJQ.views.groups.SelectGroupsModal({
			selectorOptions: {
				isSingleChoice: true,
				selectedGroupIds: this.model.group ? this.model.group.id : null
			},
			onSave: _.bind(function (group) {
				this.model.set('group', group);
				this.renderGroup();
			}, this)
		});
	},
	deleteGroup: function () {
		this.model.set('group', null);
		this.renderGroup();
	},
	onSave: function () {
		if (this.fileUploader != null && this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this expense?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});
